module.exports = __webpack_public_path__ + "fdd689bdd2d113eceb98560afbb9edde.MP3";